import { usePetitionDetailsPageData, usePetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';
import type { PetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';

type LastNameInitialExperiment = PetitionDetailsPageUserData['experiments']['signFormLastNameInitialExperiment'];

type LastNameInitialExperimentResult = Readonly<{
	experiment: LastNameInitialExperiment;
	petitionId: string;
	/** False for fallback and QA-override sessions — neither is ever exposed. */
	isRealAssignment: boolean;
	/**
	 * Whether to render the server-abbreviated name instead of the full display name.
	 *
	 * Not necessarily an initial: user_service decides what each locale can hide, which is `David O.` in
	 * English but the family name alone for ja/ko, and the unchanged display name where nothing can be
	 * hidden. The client only chooses which field to read.
	 *
	 * `control` and `fake_control` both render full names — that's where `fake_control` collapses onto
	 * control visually while staying a distinct analysis arm.
	 */
	showAbbreviated: boolean;
}>;

export function useLastNameInitialExperiment(): LastNameInitialExperimentResult {
	const {
		data: {
			petition: { id },
		},
	} = usePetitionDetailsPageData();
	const {
		data: { experiments },
	} = usePetitionDetailsPageUserData();

	const experiment = experiments.signFormLastNameInitialExperiment;

	return {
		experiment,
		petitionId: `petition_${id}`,
		isRealAssignment: !experiment.fallback && !experiment.override,
		showAbbreviated: experiment.variation === 'variant_1',
	};
}
